// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';


function serialize(prim) {
  return prim;
}

function deserialize(prim) {
  return prim;
}

exports.serialize = serialize;
exports.deserialize = deserialize;
/* No side effect */
